import { dId, logger, confirm_box } from "./common.js";
import { ajax } from "./ajax.js";

/**
 * Add experiencia to user cart
 */

declare const PAGE_LANG:string;

logger("listen for click on add_cart button");

const msg: { [key: string]: any } = {
  "ENG": {
    "ok" : "Product added to cart",
    "ko" : "Error adding product to cart"
  },
  "ESP": {
    "ok" : "Producto añadido al carrito",
    "ko" : "Error añadiendo producto al carrito"
  }
};


const btn = <HTMLInputElement>dId('add_cart');
btn.addEventListener('click', add_cart);

function add_cart() {

  const id = btn.getAttribute('data-id');

  if (!id) {
    logger("No data-id attribute found on add_cart button");
    return;
  }

  const fd = new FormData();
  fd.append("action", "add");
  fd.append("id", id);
  fd.append("type", "ex");

	fetch(ajax.get("mycart"), {
		method: "POST",
		body: fd
	}).then(response => response.json())
    .then(data => {
      console.log(data);
      if (data.status === 'ok') {
        confirm_box( msg[PAGE_LANG].ok, "OK", "", "", "");
      } else {
        throw new Error(data.message);
      }
    })
    .catch(error => {
      logger('There was an error! ' + error);
      confirm_box( msg[PAGE_LANG].ko, "OK", "", "", "");
    });
    
}